<template>
  <div class="popupWrap">
    <TableToolTemp
      :toolListProps="{
        toolTitle: tempObj.planName,
      }"
    ></TableToolTemp>
    <!--<template v-if="tableData">
      <div v-for="product in tableData" :key="product.code" class="insurance-wrapper">
        <TableToolTemp class="tab-tool-sub" :toolListProps="{
              toolTitle: '险种：'+product.productName,
            }"
        ></TableToolTemp>
        <el-card class="box-card">
          <ul class="formDetails">
            <li>
              保额：{{ product.amount }}{{ product.amountUnit | getDicItemName('gcbs.unit') }}
              {{ product.amountCalcType === '1' ? '' : '/人' }}
            </li>
            <li>
              保费：{{ product.premiums }}{{ product.premiumsUnit | getDicItemName('gcbs.unit') }}
              {{ product.premiumsCalcType === '1' ? '' : '/人' }}
            </li>
            <li v-if="product.extraAttr.deductible.inputType === '1'">
              免赔额：{{ product.extraAttr.deductible.amount }}{{ product.extraAttr.deductible.unit | getDicItemName('gcbs.unit') }}
            </li>
            <li v-if="product.extraAttr.compensationRatio.inputType === '1'">
              赔付比例：{{ product.extraAttr.compensationRatio.amount }}{{ product.extraAttr.compensationRatio.unit | getDicItemName('gcbs.unit') }}
            </li>
            <li v-if="product.extraAttr.compensationDays.inputType === '1'">
              赔付天数：{{ product.extraAttr.compensationDays.amount }}{{ product.extraAttr.compensationDays.unit | getDicItemName('gcbs.unit') }}
            </li>
          </ul>
        </el-card>
        <el-table style="margin-bottom: 20px;" v-if="product.liabilityList && product.liabilityList.length > 0" class="dt-table typeTable" :data="product.liabilityList" stripe v-hover >
          <el-table-column label="责任名称">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="保额">
            <template slot-scope="scope">
              <template v-if="scope.row.amount">
                {{ scope.row.amount }}
                {{ scope.row.amountUnit | getDicItemName('gcbs.unit') }}
                {{ scope.row.amountCalcType === '1' ? '' : '/人' }}
              </template>
              <template v-else>&#45;</template>
            </template>
          </el-table-column>
          <el-table-column label="保费">
            <template slot-scope="scope">
              <template v-if="scope.row.premiums">
                {{ scope.row.premiums }}
                {{ scope.row.premiumsUnit | getDicItemName('gcbs.unit') }}
                {{ scope.row.premiumsCalcType === '1' ? '' : '/人' }}
              </template>
              <template v-else>&#45;</template>
            </template>
          </el-table-column>
          <el-table-column label="免赔额/天">
            <template slot-scope="scope">
              <template v-if="scope.row.extraAttr
                && scope.row.extraAttr.deductible
                && scope.row.extraAttr.deductible.amount"
              >
                {{ scope.row.extraAttr.deductible.amount }}
                {{ scope.row.extraAttr.deductible.unit | getDicItemName('gcbs.unit') }}
              </template>
              <template v-else>&#45;</template>
            </template>
          </el-table-column>
          <el-table-column label="赔付比例">
            <template slot-scope="scope">
              <template v-if="scope.row.extraAttr
                && scope.row.extraAttr.compensationRatio
                && scope.row.extraAttr.compensationRatio.amount"
              >
                {{ scope.row.extraAttr.compensationRatio.amount }}
                {{ scope.row.extraAttr.compensationRatio.unit | getDicItemName('gcbs.unit') }}
              </template>
              <template v-else>&#45;</template>
            </template>
          </el-table-column>
          <el-table-column label="赔付天数">
            <template slot-scope="scope">
              <template v-if="scope.row.extraAttr
                && scope.row.extraAttr.compensationDays
                && scope.row.extraAttr.compensationDays.amount"
              >
                {{ scope.row.extraAttr.compensationDays.amount }}
                {{ scope.row.extraAttr.compensationDays.unit | getDicItemName('gcbs.unit') }}
              </template>
              <template v-else>&#45;</template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>-->

    <!-- <el-table class="dt-table typeTable" :data="tableData" stripe v-hover >
      <el-table-column prop="productName" label="险种名称"></el-table-column>
      <el-table-column label="责任名称">
        <template slot-scope="scope">
          <template v-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.code">{{ item.name }}</p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="保额">
        <template slot-scope="scope">
          <template v-if="scope.row.amount">
            {{ scope.row.amount }}{{ scope.row.amountUnit | getDicItemName('gcbs.unit') }}
            {{ scope.row.amountCalcType === '1' ? '' : '/人' }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.code">
              <template v-if="item.amount">
                {{ item.amount }}{{ item.amountUnit | getDicItemName('gcbs.unit') }}
                {{ item.amountCalcType === '1' ? '' : '/人' }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="保费">
        <template slot-scope="scope">
          <template v-if="scope.row.premiums">
            {{ scope.row.premiums }}
            {{ scope.row.premiumsUnit | getDicItemName('gcbs.unit') }}
            {{ scope.row.premiumsCalcType === '1' ? '' : '/人' }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.code">
              <template v-if="item.premiums">
                {{ item.premiums }}
                {{ item.premiumsUnit | getDicItemName('gcbs.unit') }}
                {{ item.premiumsCalcType === '1' ? '' : '/人' }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="免赔额/天">
        <template slot-scope="scope">
          <template v-if="scope.row.extraAttr.deductible.amount">
            {{ scope.row.extraAttr.deductible.amount }}
            {{ scope.row.extraAttr.deductible.unit | getDicItemName('gcbs.unit') }}
          </template>
          <template v-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.name">
              <template v-if="item.extraAttr && item.extraAttr.deductible && item.extraAttr.deductible.amount">
                {{ item.extraAttr.deductible.amount }}
                {{ item.extraAttr.deductible.unit | getDicItemName('gcbs.unit') }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="赔付比例">
        <template slot-scope="scope">
          <template v-if="scope.row.extraAttr.compensationRatio.amount">
            {{ scope.row.extraAttr.compensationRatio.amount }}
            {{ scope.row.extraAttr.compensationRatio.unit | getDicItemName('gcbs.unit') }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.name">
              <template v-if="item.extraAttr && item.extraAttr.compensationRatio && item.extraAttr.compensationRatio.amount">
                {{ item.extraAttr.compensationRatio.amount }}
                {{ item.extraAttr.compensationRatio.unit | getDicItemName('gcbs.unit') }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="赔付天数">
        <template slot-scope="scope">
          <template v-if="scope.row.extraAttr.compensationDays.amount">
            {{ scope.row.extraAttr.compensationDays.amount }}
            {{ scope.row.extraAttr.compensationDays.unit | getDicItemName('gcbs.unit') }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.name">
              <template v-if="item.extraAttr && item.extraAttr.compensationDays && item.extraAttr.compensationDays.amount">
                {{ item.extraAttr.compensationDays.amount }}
                {{ item.extraAttr.compensationDays.unit | getDicItemName('gcbs.unit') }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
    </el-table> -->
    <el-table class="dt-table typeTable" :data="tableData" stripe v-hover>
      <el-table-column prop="productName" label="险种名称"></el-table-column>
      <el-table-column label="责任名称"  :width="210" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.code">{{ item.name }}</p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="保额">
        <template slot-scope="scope">
          <template v-if="scope.row.amount">
            {{ scope.row.amount }}{{ scope.row.amountUnit | getDicItemName('gcbs.unit') }}
            {{ scope.row.amountCalcType === '1' ? '' : '/人' }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.code">
              <template v-if="item.amount">
                {{ item.amount }}{{ item.amountUnit | getDicItemName('gcbs.unit') }}
                {{ item.amountCalcType === '1' ? '' : '/人' }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="保费">
        <template slot-scope="scope">
          <template v-if="scope.row.premiums">
            {{ scope.row.premiums }}
            {{ scope.row.premiumsUnit | getDicItemName('gcbs.unit') }}
            {{ scope.row.premiumsCalcType === '1' ? '' : '/人' }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.code">
              <template v-if="item.premiums">
                {{ item.premiums }}
                {{ item.premiumsUnit | getDicItemName('gcbs.unit') }}
                {{ item.premiumsCalcType === '1' ? '' : '/人' }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="免赔额/天">
        <template slot-scope="scope">
          <template v-if="scope.row.extraAttr.deductible">
            {{ scope.row.extraAttr.deductible.amount }}
            {{ scope.row.extraAttr.deductible.unit | getDicItemName('gcbs.unit') }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.name">
              <template v-if="item.extraAttr && item.extraAttr.deductible && item.extraAttr.deductible.amount">
                {{ item.extraAttr.deductible.amount }}
                {{ item.extraAttr.deductible.unit | getDicItemName('gcbs.unit') }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="赔付比例">
        <template slot-scope="scope">
          <template v-if="scope.row.extraAttr.compensationRatio">
            {{ scope.row.extraAttr.compensationRatio.amount }}
            {{ scope.row.extraAttr.compensationRatio.unit | getDicItemName('gcbs.unit') }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.name">
              <template
                v-if="item.extraAttr && item.extraAttr.compensationRatio && item.extraAttr.compensationRatio.amount"
              >
                {{ item.extraAttr.compensationRatio.amount }}
                {{ item.extraAttr.compensationRatio.unit | getDicItemName('gcbs.unit') }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="赔付天数">
        <template slot-scope="scope">
          <template v-if="scope.row.extraAttr.compensationDays">
            {{ scope.row.extraAttr.compensationDays.amount }}
            {{ scope.row.extraAttr.compensationDays.unit | getDicItemName('gcbs.unit') }}
          </template>
          <template v-else-if="scope.row.liabilityList && scope.row.liabilityList.length">
            <p v-for="item in scope.row.liabilityList" :key="item.name">
              <template
                v-if="item.extraAttr && item.extraAttr.compensationDays && item.extraAttr.compensationDays.amount"
              >
                {{ item.extraAttr.compensationDays.amount }}
                {{ item.extraAttr.compensationDays.unit | getDicItemName('gcbs.unit') }}
              </template>
            </p>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { myMixin } from '@/mixins';
import { productListPlan } from '@/api/insuranceContract';
import TableToolTemp from '@/components/layouts/TableToolTemp';

export default {
  mixins: [myMixin],
  components: {
    TableToolTemp,
  },
  props: ['isShow', 'tempObj'],
  data() {
    return {
      dicArr: ['gcbs.unit'],
      tableData: [],
    };
  },
  watch: {
    isShow(val) {
      if (val) {
        this.queryData();
      }
    },
  },
  methods: {
    init() {
      this.queryData();
    },
    queryData() {
      productListPlan({
        policyId: this.tempObj.policyId,
        policyCode: this.tempObj.policyCode,
        planId: this.tempObj.planId,
        planName: this.tempObj.planName,
      }).then((res) => {
        if (res && res.length) {
          /*res.forEach(product => {
            product.liabilityList.forEach(liability => {
              let liabilityList = new Array();
              if(liability.amountInputType === "1"
                      || liability.premiusInputType === "1"
                      || liability.extraAttr.deductible.inputType === "1"
                      || liability.extraAttr.compensationRatio.inputType === "1"
                      || liability.extraAttr.compensationDays.inputType === "1") {
                liabilityList.push(liability);
              }
              product.liabilityList = liabilityList;
            });
          });*/
          res.forEach((item) => {
            if (item.liabilityList) {
              item.liabilityList = item.liabilityList.filter((inner) => inner.hasChecked === 1);
            }
          });
          this.tableData = res;
        } else {
          this.tableData = [];
        }
      });
    },
    close() {
      this.$emit('update:isShow', false);
    },
  },
};
</script>

<style lang="less">
.typeTable {
  margin-bottom: 20px;
  .cell {
    p {
      line-height: 30px;
    }
  }
}
/* ---------------------
       from表单
--------------------- */
.formDetails {
  display: flex;
  flex-wrap: wrap;
  li {
    box-sizing: border-box;
    width: 25%;
    word-break: break-all;
  }
}

.insurance-wrapper {
  color: #55555a;
  .box-card {
    margin: 0px 0px 20px 0px;
    color: #55555a;
    font-weight: 400;
  }
}
</style>
